// promoción al comprar X pack de producto A
import { useState, useEffect } from 'react';

import ProductItem from '../Product/ProductItem';
import ProductSelect from '../Product/ProductSelect';

import { getTitle } from '../../../../helpers/admin/productHelper';
import { savePromoToBD } from '../../../../actions/admin/promotion';
import { basicMsg, confirmDialog } from '../../../../actions/swal_msg';
import { getProductPromotions } from '../../../../helpers/admin/promotion/promotionHelper';

import {
    Typography, Grid, TextField, Stack, Button,
    ToggleButtonGroup, ToggleButton
} from "@mui/material";
import StarPurple500Icon from '@mui/icons-material/StarPurple500';

import { regex_dec, regex_num, regex_two_dec } from '../../../../constants/regex';
import { PROMO_PRODUCT } from '../../../../constants/shop/promotion/promotion_const';

const PromoFive = ({
    today, promotion, allProducts,
    activePromotion, setActivePromotion,
    otherPromotion, setOtherPromotion
}) => {
    const { promo, start_date, end_date } = promotion;

    const [data, setData] = useState({
        label: 'Descuento (%)',
        maxLength: 5,
        helperText: '% de descuento',
        type: 'Descuento % en producto'
    });
    const { label, maxLength, helperText, type } = data;

    // valor de descuento
    const [discount, setDiscount] = useState('');
    // tipo de descuento
    const [alignment, setAlignment] = useState('percentage');
    // cantidad
    const [qty, setQty] = useState('');
    // producto A seleccionado
    const [productA, setProductA] = useState(PROMO_PRODUCT);
    const { variant_id, title, variant_title, price } = productA;

    const setTextData = () => {
        const txt1 = qty !== '' ? qty : 'X';
        if (alignment === 'fixed')
            setData(e => ({
                ...e, label: 'Descuento ($)',
                maxLength: 10,
                helperText: `$${discount} de descuento (después de IVA)`,
                type: `$${discount} de descuento al comprar ${txt1} piezas de ${
                    variant_id ? getTitle(title, variant_title)
                    : 'producto'
                }`
            }));
        else if (alignment === 'percentage')
            setData(e => ({
                ...e, label: 'Descuento (%)',
                maxLength: 5,
                helperText: `${discount}% de descuento`,
                type: `${discount}% de descuento al comprar ${txt1} piezas de ${
                    variant_id ? getTitle(title, variant_title)
                    : 'producto'
                }`
            }));
        else
            setData(e => ({
                ...e, label: 'X',
                maxLength: 1,
                helperText: `Descuento incorrecto`,
                type: 'No se reconoce tipo de descuento en producto'
            }));
    };

    useEffect(() => {
        setTextData();
    }, [discount, productA, alignment]);

    const handleInputChange = ({ target }) => {
        const name = target.name;
        const value = target.value;
        if (name === 'discount') {
            if (value === '' || regex_dec.test(value))
                setDiscount(value);
        } else if (name === 'qty') {
            if (value === '' || regex_num.test(value))
                setQty(value);
        }
    };

    const handleAlignment = (event, newAlignment) => {
        if (newAlignment !== null)
            setAlignment(newAlignment);
    };
    
    // producto A seleccionado, se introdujo descuento
    const validation = () => {
        let err = '';

        // valor de descuento a numérico
        const num = Number(discount);
        const pkg_qty = Number(qty);
        if (variant_id === '')
            err = 'Seleccione producto';
        else if (discount === '')
            err = alignment === 'fixed' ?
                'Seleccione la cantidad de descuento' :
                'Seleccione el porcentaje de descuento';
        else if (qty === '')
            err = 'Ingrese la cantidad de producto';
        else if (alignment === 'percentage' && (num < 1 || num > 100))
            err = 'Porcentaje de descuento es incorrecto';
        else if (alignment === 'fixed') {
            if (!regex_two_dec.test(discount))
                err = 'Valor de descuento es incorrecto';
            else if (num > (price * pkg_qty))
                err = 'Descuento supera precio de producto';
        }
        
        if (!err && (pkg_qty < 2 || pkg_qty > 99))
            err = 'Cantidad de producto es incorrecto';
        
        if (err) {
            basicMsg(err);
            return false;
        }
        return true;
    };

    // verificar si producto tiene promoción
    const checkPromos = async() => {
        if (validation()) {
            const ActivePromotions = getProductPromotions(promo, activePromotion, otherPromotion, { productA });
            if (ActivePromotions.status) {
                if (await confirmDialog('¿Registrar la promoción?', ActivePromotions.html, 'Registrar'))
                    savePromo();
            } else savePromo();
        }
    };

    // guardar promoción en BD
    const savePromo = async () => {
        const Model = {
            ...promotion,
            pkg_qty: qty,
            discount,
            discount_type: alignment,
            variant_a: {
                _id: variant_id,
                title: title,
                variant_title: variant_title
            }
        }
        const req = await savePromoToBD(Model, 'save-promo-five');
        if (req.status) {
            const { _id } = req.resp;
            // promoción activa
            if (start_date <= today && end_date >= today)
                setActivePromotion(e => ([
                    ...e, { _id, ...Model }
                ]));
            else // promoción guardada (no activa)
                setOtherPromotion(e => ([
                    ...e, { _id, ...Model }
                ]));
            // limpiar campos
            setProductA(PROMO_PRODUCT);
            setDiscount('');
        }
    };

    return (
        <Grid container spacing={6}>
            <Grid item xs={12}>
                <Stack
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={2}
                    sx={{ mb: 2 }}>
                    <Typography variant="h6">
                        { `Promoción: ${type}` }
                    </Typography>
                    <StarPurple500Icon />
                </Stack>

                <Grid container spacing={4}>
                    {
                        variant_id !== '' &&
                            <ProductItem
                                product={productA}
                                setProduct={setProductA}
                                alt={'producto-A'}
                                text={'Producto seleccionado'}
                            />
                    }
                </Grid>
                
                <ToggleButtonGroup
                    sx={{ mt: 2 }}
                    color="primary"
                    value={ alignment }
                    exclusive
                    onChange={ handleAlignment }
                    aria-label="discount"
                    >
                    <ToggleButton value="type" disabled>Tipo descuento</ToggleButton>
                    <ToggleButton value="percentage">%</ToggleButton>
                    <ToggleButton value="fixed">$</ToggleButton>
                </ToggleButtonGroup>

                <TextField fullWidth
                    sx={{ mt: 1 }}
                    name="discount"
                    label={ label }
                    variant="standard"
                    inputProps={{ maxLength }}
                    helperText={ helperText }
                    value={ discount }
                    onChange={handleInputChange}
                />
                
                <TextField fullWidth
                    sx={{ mt: 1 }}
                    name="qty"
                    label="Cantidad necesaria para aplicar descuento"
                    variant="standard"
                    inputProps={{ maxLength: 2 }}
                    helperText={ `${qty} Pack`.trim() }
                    value={qty}
                    onChange={handleInputChange}
                />

                {
                    variant_id !== '' &&
                        <Button variant="contained"
                            onClick={ checkPromos }>
                            Guardar promoción
                        </Button>
                }

                <ProductSelect
                    text={''}
                    setProduct={ setProductA }
                    allProducts={allProducts}
                />
            </Grid>
        </Grid>
    );
};

export default PromoFive;